import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-by-id',
  templateUrl: './edit-by-id.component.html',
  styleUrls: ['./edit-by-id.component.scss'],
})
export class EditByIdComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;
  submitted = false;
  EppEditByID: FormGroup;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private gs: GeneralService,
    private fb: FormBuilder,
    private datepipe: DatePipe
  ) {}

  Epp = [];
  ActiveArray = [
    {
      name: 'InActive',
      value: 0,
    },
    {
      name: 'Active',
      value: 1,
    },
  ];

  selectedValue = this.ActiveArray[0];
  selectedUser = null;

  ngOnInit() {
    this.breadCrumbItems = [
      {
        label: 'EPP',
        path: '/',
      },
      { label: 'Edit EPP', path: 'EditById/:UserID', active: true },
    ];

    this.EppEditByID = new FormGroup({
      start_date: new FormControl(null),
      end_date: new FormControl(null),
      active: new FormControl('', Validators.required),
    });

    this.gs
      .getEppByUserId(this.route.snapshot.params.UserID)
      .subscribe((Response: any) => {
        this.Epp = Response.data;
        console.log(Response.data);

        this.Epp.map((item) => {
          console.log(item);

          item.start_date = this.datepipe.transform(
            item.start_date,
            'yyyy-MM-dd'
          );
          item.end_date = this.datepipe.transform(item.end_date, 'yyyy-MM-dd');
          // item.active = item.active = 1 ? 'Active' : 'Inactive';
        });
        // this.EppEditByID.patchValue(this.Epp[0]);
        // console.log(this.Epp[0].active);
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }

  // activeSelected(e) {
  //   console.log(e);
  // }
  f() {
    return this.EppEditByID.controls;
  }

  onSubmit() {
    console.log(this.route.snapshot.params.UserID, this.EppEditByID.value);

    console.log(this.EppEditByID.value);
    this.submitted = true;
    if (this.EppEditByID.valid) {
      // 1 is Property ID
      this.isLoading = true;
      this.gs
        .UpdateEppByUserId(
          this.route.snapshot.params.UserID,
          this.EppEditByID.value
        )
        .subscribe((data) => {
          this.isLoading = false;
          // console.log(this.EPPEdit.value);
          // console.log('Meet');

          if (data.status === 200) {
            this.submitted = false;
            Swal.fire({
              title:
                'Are you sure, you want to update this for all survey no.?',
              text: data.message,
              type: 'warning',
            }).then(() => {
              this.submitted = false;
              // this.reFresh.emit();
              // this.router.navigate(['']);
            });
          } else {
            Swal.fire({
              title: data.error_code,
              text: data.message,
              type: 'error',
            }).then(() => {
              this.router.navigate(['']);
            });
          }
        },(error) => {                              //Error callback
          this.isLoading = false;
          Swal.fire({
            title: error.status,
            text: "Internal Server Error",
            type: "error",
          });
          //throw error;   //You can also throw the error to a global error handler
        });
    }

    // if (this.EppEditByID.valid) {
    //   Swal.fire({
    //     title: 'Are you sure, you want to update this for all survey no.?',
    //     type: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Yes',
    //     cancelButtonText: 'No',
    //   }).then((result) => {
    //     if (result.value) {
    //       this.isLoading = true;
    //       this.gs
    //         .UpdateEppByUserId(
    //           this.route.snapshot.params.UserID,
    //           this.EppEditByID.value
    //         )
    //         .subscribe((data) => {
    //           this.isLoading = false;
    //           if (data.status === 200) {
    //             Swal.fire({
    //               title: 'Epp Updated Sucessfully',
    //               text: data.message,
    //               type: 'success',
    //             }).then(() => {
    //               this.router.navigate(['']);
    //             });
    //           } else {
    //             Swal.fire({
    //               title: data.error_code,
    //               text: data.message,
    //               type: 'error',
    //             });
    //           }
    //         });
    //     } else if (result.dismiss === Swal.DismissReason.cancel) {
    //     }
    //   });
    // }
  }
}
